<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Variables Cargue Masivo - {{datosEditFuente.nombEntidad}}</h5>
    </div>
    <div class="card-body">
      <form>
        <div class="col-auto">
          <a type="a" class="btn btn-secondary" style="color: white;" (click)="Regresar()">Volver</a>
        </div>
        <br>
        <div class="table-responsive overflow-scroll" style="align-content: center;">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col" class="text-center" style="background-color: lightgrey;">Variable</th>
                <th scope="col" class="text-center" style="background-color: lightgrey;">Items</th>
                <th scope="col" class="text-center" style="background-color: lightgrey;">Obligatoria</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of FuenteParametrica | paginate:{ itemsPerPage: 5, currentPage: page }">
                <td style="text-align: center;">
                  <a *ngIf="s.parametrica.subitem" type="a" class="btn btn-light" id="fuentes" (click)="ItemsParametrica(s)">{{s.parametrica.nombre}}</a>
                  <a *ngIf="!s.parametrica.subitem" type="a" class="btn btn-light" id="fuentes">{{s.parametrica.nombre}}</a>
                </td>
                <td style="text-align: center;">
                  <b *ngIf="s.parametrica.subitem">Si</b>
                  <b *ngIf="!s.parametrica.subitem">No</b>
                </td>
                <td style="text-align: center;">
                  <input class="form-check-input" type="checkbox" name="{{s.id}}-{{s.parametrica.nombre}}" [(ngModel)]="s.obligatoria" data-toggle="modal" data-target="#obligatoriedad" data-backdrop="static" (change)="CambioObligatoriedad(s)">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row justify-content-center">
          <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
        </div>
      </form>
    </div>
  </div>
</body>

<!--Confirmar obligatoriedad-->
<div class="modal fade bd-example-modal-md" id="obligatoriedad" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Confirmar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closemodalconfirma  (click)="ngOnInit()">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div *ngIf="FuenteParametricaEditar.obligatoria" class="row" style="text-align: center;">
            <p>Confirma que desea cambiar a obligatoria la parametrica <b>{{NombreParametricaEditar}}</b> para la fuente <b>{{datosEditFuente.nombEntidad}}</b></p>
          </div>
          <div *ngIf="!FuenteParametricaEditar.obligatoria" class="row" style="text-align: center;">
            <p>Confirma que desea cambiar a no obligatoria la parametrica <b>{{NombreParametricaEditar}}</b> para la fuente <b>{{datosEditFuente.nombEntidad}}</b></p>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="ngOnInit()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="!btnguardar" (click)="guardar()">Aceptar</button>
      </div>
    </div>
  </div>
</div>

<!--Ver items de parametricas-->
<button class="btn btn-primary btn-sm" #openmodalitems data-toggle="modal"  data-target="#vervariables" style="visibility: hidden;" data-backdrop="static">Modal</button>
<div class="modal fade bd-example-modal-lg" id="vervariables" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Variables Cargue Masivo - {{datosEditFuente.nombEntidad}} - Items {{NombreParametricaEditar}}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid overflow-scroll">
          <div class="table-responsive" style="align-content: center;">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" class="text-center" style="background-color: lightgrey;">Codigo</th>
                  <th scope="col" class="text-center" style="background-color: lightgrey;">Descripción item</th>
                  <th scope="col" class="text-center" style="background-color: lightgrey;">Obligatoria</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of ItemsFuenteParametrica">
                  <td style="text-align: center;">
                    {{r.variable.codigo}}
                  </td>
                  <td style="text-align: center;">
                    {{r.variable.nombre}}
                  </td>
                  <td style="text-align: center;">
                    <input class="form-check-input" type="checkbox" name="{{r.id}}{{r.variable.codigo}}" [(ngModel)]="r.obligatoria" data-toggle="modal" data-bs-target="#obligatoriedad" data-backdrop="static" (change)="CambioObligatoriedadItem(r)">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closemodalitems data-dismiss="modal">Cerrar</button>
        <!--button type="button" class="btn btn-primary" [disabled]="!btnguardar" (click)="GuardarItems()" (click)="ngOnInit()">Guardar cambios</button-->
      </div>
    </div>
  </div>
</div>

<!--Confirmar obligatoriedad items-->
<button class="btn btn-primary btn-sm" #openmodalconfirvaria data-toggle="modal"  data-target="#obligatoriedaditems" style="visibility: hidden;" data-backdrop="static">Modal</button>
<div class="modal fade bd-example-modal-md" id="obligatoriedaditems" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Confirmar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="ItemsParametrica(FuenteParametricaEditar)">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div *ngIf="FuenteParametricaEditar.obligatoria" class="row" style="text-align: center;">
            <p>Confirma que desea cambiar a obligatorio el item <b>{{NombreVariableEditar}}</b> para la fuente <b>{{datosEditFuente.nombEntidad}}</b></p>
          </div>
          <div *ngIf="!FuenteParametricaEditar.obligatoria" class="row" style="text-align: center;">
            <p>Confirma que desea cambiar a no obligatorio el item <b>{{NombreVariableEditar}}</b> para la fuente <b>{{datosEditFuente.nombEntidad}}</b></p>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closemodalconfirvaria data-dismiss="modal" (click)="ItemsParametrica(FuenteParametricaEditar)">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="!btnguardar" (click)="guardarItem()">Aceptar</button>
      </div>
    </div>
  </div>
</div>
